import type { ValidationResult } from '../helpers/types';
import { formatValidationResponse } from '../helpers/utils';

const hasOneDigitRegex = /(\d+)/;
const digitMessage = 'Should have at least one digit';

export const validateOneDigit = (password: string): ValidationResult => {
  const isRuleValid = hasOneDigitRegex.test(password);
  return formatValidationResponse(isRuleValid, digitMessage);
};
